import React from 'react';

/*
    - ihoDesignSystem
*/
import { Alert, Box, Button, Grid, Modal, Select, TextField, Typography } from '@iho-design-system/Loader';

/*
    - svg
*/
import editSVG from '../../../assets/images/icons/edit.svg';

/*
    - api
*/
import addBankAccountAPI from '../../../api/add/BankAccount';

const Toolbar = ({ props, alertProps, reloadFinanceProps }) => {

    /*
        - defaultData
    */
    const [bankAccount, setbankAccount] = React.useState([]);
    const [addBankAccountParameters, setAddBankAccountParameters] = React.useState({
        accountName: {
            value: '',
            color: 'dark'
        },
        cardNumber: {
            value: '',
            color: 'dark'
        },
        bankName: {
            value: '',
            color: 'dark'
        },
        bankAccount: {
            value: '',
            color: 'dark'
        },
        sheba: {
            value: '',
            color: 'dark'
        }
    });
    const bankNameList = [
        '',
        'بانک ملّی ایران',
        'بانک اقتصاد نوین',
        'بانک قرض‌الحسنه مهر ایران',
        'بانک سپه',
        'بانک پارسیان',
        'بانک قرض‌الحسنه رسالت',
        'بانک صنعت و معدن',
        'بانک کارآفرین',
        'بانک کشاورزی',
        'بانک سامان',
        'بانک مسکن',
        'بانک سینا',
        'بانک توسعه صادرات ایران',
        'بانک خاورمیانه',
        'بانک توسعه تعاون',
        'بانک شهر',
        'پست بانک ایران',
        'بانک دی',
        'بانک صادرات',
        'بانک ملت',
        'بانک تجارت',
        'بانک رفاه',
        'بانک حکمت ایرانیان',
        'بانک گردشگری',
        'بانک ایران زمین',
        'بانک قوامین',
        'بانک انصار',
        'بانک سرمایه',
        'بانک پاسارگاد'
    ];

    React.useEffect(() => {
        if (props.bankAccount.status === 200) {
            setbankAccount(props.bankAccount.data);
        }
    }, [props]);

    /*
        - addBankAccountHandler
    */
    const addBankAccountHandler = (key, value) => {
        if (key === 'accountName' && value !== '') {
            setAddBankAccountParameters({
                ...addBankAccountParameters,
                accountName: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'accountName' && value === '') {
            setAddBankAccountParameters({
                ...addBankAccountParameters,
                accountName: {
                    value: value,
                    color: 'danger'
                }
            });
        }
        if (key === 'cardNumber' && value !== '' && value.length === 16) {
            setAddBankAccountParameters({
                ...addBankAccountParameters,
                cardNumber: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'cardNumber' && (value === '' || value.length !== 16)) {
            setAddBankAccountParameters({
                ...addBankAccountParameters,
                cardNumber: {
                    value: value,
                    color: 'danger'
                }
            });
        }
        if (key === 'bankName' && value !== '') {
            setAddBankAccountParameters({
                ...addBankAccountParameters,
                bankName: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'bankName' && value === '') {
            setAddBankAccountParameters({
                ...addBankAccountParameters,
                bankName: {
                    value: value,
                    color: 'danger'
                }
            });
        }
        if (key === 'bankAccount' && value !== '') {
            setAddBankAccountParameters({
                ...addBankAccountParameters,
                bankAccount: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'bankAccount' && value === '') {
            setAddBankAccountParameters({
                ...addBankAccountParameters,
                bankAccount: {
                    value: value,
                    color: 'danger'
                }
            });
        }
        if (key === 'sheba' && value !== '' && value.length === 24) {
            setAddBankAccountParameters({
                ...addBankAccountParameters,
                sheba: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'sheba' && (value === '' || value.length !== 24)) {
            setAddBankAccountParameters({
                ...addBankAccountParameters,
                sheba: {
                    value: value,
                    color: 'danger'
                }
            });
        }
    }

    /*
        - addBankAccount
    */
    const addBankAccount = async () => {
        let parameters = {};
        let isValid = 1;
        if (addBankAccountParameters.accountName.value === '') {
            setAddBankAccountParameters({
                ...addBankAccountParameters,
                accountName: {
                    value: addBankAccountParameters.accountName.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (addBankAccountParameters.cardNumber.value === '' || addBankAccountParameters.cardNumber.value.length !== 16) {
            setAddBankAccountParameters({
                ...addBankAccountParameters,
                cardNumber: {
                    value: addBankAccountParameters.cardNumber.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (addBankAccountParameters.bankName.value === '') {
            setAddBankAccountParameters({
                ...addBankAccountParameters,
                bankName: {
                    value: addBankAccountParameters.bankName.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (addBankAccountParameters.bankAccount.value === '') {
            setAddBankAccountParameters({
                ...addBankAccountParameters,
                bankAccount: {
                    value: addBankAccountParameters.bankAccount.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (addBankAccountParameters.sheba.value === '' || addBankAccountParameters.sheba.value.length !== 24) {
            setAddBankAccountParameters({
                ...addBankAccountParameters,
                sheba: {
                    value: addBankAccountParameters.sheba.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (isValid === 1) {
            parameters.AccountName = addBankAccountParameters.accountName.value;
            parameters.CardNumber = addBankAccountParameters.cardNumber.value;
            parameters.BankName = addBankAccountParameters.bankName.value;
            parameters.bankAccount = addBankAccountParameters.bankAccount.value;
            parameters.Sheba = addBankAccountParameters.sheba.value;
            let result = await addBankAccountAPI(parameters);
            if (result === 'success') {
                alertProps(['success', 'با موفقیت انجام شد']);
                reloadFinanceProps(Math.floor(Math.random() * 100));
                closeModal('addBankAccountModal');
            } else {
                alertProps(['danger', 'خطایی رخ داده است']);
            }
            setAddBankAccountParameters({
                accountName: {
                    value: '',
                    color: 'dark'
                },
                cardNumber: {
                    value: '',
                    color: 'dark'
                },
                bankName: {
                    value: [],
                    color: 'dark'
                },
                bankAccount: {
                    value: '',
                    color: 'dark'
                },
                sheba: {
                    value: '',
                    color: 'dark'
                }
            });
        }
    }

    /*
        - modal
    */
    const openModal = (modal) => {
        document.querySelector(`.${modal}`).classList.remove('d-none');
    }

    const closeModal = (modal) => {
        document.querySelector(`.${modal}`).classList.add('d-none');
    }

    return (
        <React.Fragment>
            <Grid>
                <Grid.Wrapper>
                    <Grid.Item
                        size='col-12 md-8'>
                        <Typography
                            component='h4'
                            ms={{
                                fontWeight: 'normal !important'
                            }}>
                            لیست شماره حساب‌ها
                        </Typography>
                        <Typography
                            className={`d-block`}
                            component='p'
                            ms={{
                                color: '#6F6F7E'
                            }}>
                            کارت‌های خود را، برای استفاده راحت تر در لیست اضافه کنید.
                        </Typography>
                    </Grid.Item>
                    <Grid.Item
                        className={`text-left`}
                        size='col-12 md-4'>
                        {bankAccount.length <= 9 &&
                            <Button
                                onClick={() => openModal('addBankAccountModal')}
                                variant='filled'
                                color='primary'
                                ms={{
                                    '@media(max-width:576px)': {
                                        width: '100% !important'
                                    }
                                }}>
                                افزودن حساب
                            </Button>
                        }
                        {bankAccount.length > 9 &&
                            <Button
                                variant='filled'
                                color='danger'
                                ms={{
                                    '@media(max-width:576px)': {
                                        width: '100% !important'
                                    }
                                }}>
                                افزودن حساب
                            </Button>
                        }
                    </Grid.Item>
                    {bankAccount.length > 9 &&
                        <Grid.Item
                            size='col-12'>
                            <Alert
                                className={`w-100 position-static`}
                                color='danger'
                                ms={{
                                    boxShadow: 'none !important'
                                }}>
                                کاربر گرامی، شما مجاز به ثبت حداکثر 10 حساب بانکی می باشید.
                            </Alert>
                        </Grid.Item>
                    }
                </Grid.Wrapper>
            </Grid>
            <Modal
                className={`addBankAccountModal`}>
                <Modal.Wrapper
                    size='xs'
                    ms={{
                        '@media(max-width:576px)': {
                            width: 'calc(100% - 12px) !important'
                        }
                    }}>
                    <Modal.Header
                        className={`my-md mt-0 border-solid-bottom border-light`}>
                        افزودن حساب
                        <Box />
                    </Modal.Header>
                    <Typography
                        className={`px-lg`}>
                        اطلاعات حساب بانکی خود را وارد نمایید.
                    </Typography>
                    <Box
                        className={`p-sm`}
                        component='form'>
                        <Grid>
                            <Grid.Wrapper>
                                <Grid.Item
                                    size='col-12'>
                                    <TextField
                                        onChange={(event) => addBankAccountHandler('accountName', event)}
                                        color={addBankAccountParameters.accountName.color}
                                        label='نام صاحب حساب '
                                        icon={editSVG}
                                        value={addBankAccountParameters.accountName.value} />
                                </Grid.Item>
                                <Grid.Item
                                    size='col-12 md-6'>
                                    <TextField
                                        onChange={(event) => addBankAccountHandler('cardNumber', event)}
                                        color={addBankAccountParameters.cardNumber.color}
                                        label='شماره کارت'
                                        icon={editSVG}
                                        value={addBankAccountParameters.cardNumber.value} />
                                </Grid.Item>
                                <Grid.Item
                                    size='col-12 md-6'>
                                    <Select
                                        onChange={(event) => addBankAccountHandler('bankName', event)}
                                        color={addBankAccountParameters.bankName.color}
                                        label='نام بانک'
                                        search
                                        init={bankNameList[0]}>
                                        {bankNameList.map((obj, index) => {
                                            if (obj !== '') {
                                                return (
                                                    <Select.Item
                                                        key={index}
                                                        value={obj}>
                                                        {obj}
                                                    </Select.Item>
                                                )
                                            }
                                            return null;
                                        })}
                                    </Select>
                                </Grid.Item>
                                <Grid.Item
                                    size='col-12 md-6'>
                                    <TextField
                                        onChange={(event) => addBankAccountHandler('bankAccount', event)}
                                        color={addBankAccountParameters.bankAccount.color}
                                        label='شماره حساب'
                                        icon={editSVG}
                                        value={addBankAccountParameters.bankAccount.value} />
                                </Grid.Item>
                                <Grid.Item
                                    size='col-12 md-6'>
                                    <TextField
                                        onChange={(event) => addBankAccountHandler('sheba', event)}
                                        color={addBankAccountParameters.sheba.color}
                                        label='شماره شبا'
                                        icon={editSVG}
                                        value={addBankAccountParameters.sheba.value} />
                                </Grid.Item>
                                <Grid.Item
                                    className={`d-flex`}
                                    size='col-12 md-6'>
                                    <Button
                                        onClick={addBankAccount}
                                        className={`w-25`}
                                        variant='filled'
                                        color='primary'>
                                        تایید
                                    </Button>
                                    <Box
                                        className={`mx-sm`} />
                                    <Button
                                        onClick={() => closeModal('addBankAccountModal')}
                                        className={`w-25`}
                                        variant='outlined'
                                        color='primary'>
                                        انصراف
                                    </Button>
                                </Grid.Item>
                            </Grid.Wrapper>
                        </Grid>
                    </Box>
                </Modal.Wrapper>
            </Modal>
        </React.Fragment>
    );

}

export default Toolbar;